export const experienceData = [
  {
    id: 1,
    company: "Buyezzy Private Limited",
    jobtitle: "Software Development Engineer-2",
    startYear: "Jan 2024",
    endYear: "Present",
  },
  {
    id: 2,
    company: "Cogoport Freight Pvt. Ltd.",
    jobtitle: "Software Engineer",
    startYear: "July 2022",
    endYear: "Nov 2023",
  },
  {
    id: 3,
    company: "Cogoport Freight Pvt. Ltd.",
    jobtitle: "Associate Software Engineering Intern",
    startYear: "Feb 2022",
    endYear: "June 2022",
  },
];
